module.exports = __webpack_public_path__ + "img/newsImg3-8.e44959ae.png";